import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { AssetAssignmentHistory } from '../models/asset-assignment';
import { PageResult } from '@core/model/pagination/page-result';
import { GetFuelCardAssignmentHistoryGQL, GetTollAssignmentToFleetHistoryGQL, TelematicDeviceAssignmentHistoryGQL } from '@generated/queries';

@Injectable({
  providedIn: 'root'
})
export class AssetAssignmentService {

constructor(
  private history: GetTollAssignmentToFleetHistoryGQL,
  private fuelCardAssignHistory: GetFuelCardAssignmentHistoryGQL,
  private telematicDeviceAssignHistory: TelematicDeviceAssignmentHistoryGQL,
) { }

getTollFleetAssignmentHistory(tollDeviceId: string) {
    return firstValueFrom(
      this.history.fetch(
        { deviceId: tollDeviceId },
        { fetchPolicy: 'network-only' },
      ).pipe(
        map(x => new PageResult<AssetAssignmentHistory>({
          items: x.data?.tollDeviceFleetAssignmentHistory.items ?? [],
          totalCount:
            x.data?.tollDeviceFleetAssignmentHistory?.totalCount ?? 0,
        }),),
      )
    );
  }

  getFuelCardAssignmentHistory(fuelCardId: string) {
      return firstValueFrom(
        this.fuelCardAssignHistory.fetch(
          { fuelCardId: fuelCardId },
          { fetchPolicy: 'network-only' },
        ).pipe(
          map(x => new PageResult<AssetAssignmentHistory>({
            items: x.data?.fuelCardAssignmentHistory.items ?? [],
            totalCount:
              x.data?.fuelCardAssignmentHistory?.totalCount ?? 0,
          }),),
        )
      );
    }

    getTelematicDeviceAssignmentHistory(telematicDeviceId: string) {
      return firstValueFrom(
        this.telematicDeviceAssignHistory.fetch(
          { telematicDeviceId: telematicDeviceId },
          { fetchPolicy: 'network-only' },
        ).pipe(
          map(x => new PageResult<AssetAssignmentHistory>({
            items: x.data?.telematicDeviceAssignmentHistory.items ?? [],
            totalCount:
              x.data?.telematicDeviceAssignmentHistory?.totalCount ?? 0,
          }),),
        )
      );
    }

}
